














import {Vue, Component} from 'vue-property-decorator';
import {Getter} from 'vuex-class';

@Component
export default class DimmedArea extends Vue {
  @Getter private dimmedAreaStatus!: boolean;
  @Getter private getRefreshIng!: boolean;
}
